export const SET_QR_CODE_URL = 'SET_QR_CODE_URL';
